import { render, staticRenderFns } from "./PayCollect.vue?vue&type=template&id=9a0fe86c&scoped=true&"
import script from "./PayCollect.vue?vue&type=script&lang=js&"
export * from "./PayCollect.vue?vue&type=script&lang=js&"
import style0 from "./PayCollect.vue?vue&type=style&index=0&id=9a0fe86c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a0fe86c",
  null
  
)

export default component.exports